import Phone from '../Phone'
import { IconPhone } from '../Icon'
import { useIntl, defineMessages } from 'react-intl'

export const MSG = defineMessages({
  phone: {
    id: 'Intro.mobilePhone',
    defaultMessage: 'Phone'
  }
})

export interface MobilePhoneProps {
  value: string
}

export const MobilePhone = ({ value }: MobilePhoneProps) => {
  const intl = useIntl()

  return <Phone value={value} minimal={false} iconStart={IconPhone} text={intl.formatMessage(MSG.phone)} />
}
